import * as Action from './actions';
import { AsyncOperationBuilder2 } from 'shared/helpers/redux-helpers';
import { StoreContainer } from 'shared/state/store-container';
import { getSiteId } from 'shared/helpers/reducer-helpers';

export const FetchHistory = (id: string) => {
	const state = StoreContainer.getState();
	return AsyncOperationBuilder2(Action.fetchHistory, cl => cl.valveGroupHistories_GetByValveGroupIdV2(id), {
		zoneId: id,
		siteId: getSiteId(state.profile.active),
	});
};

export const FetchLatestHistory = (id: string) => {
	const state = StoreContainer.getState();
	return AsyncOperationBuilder2(
		Action.fetchLatestHistory,
		cl => cl.valveGroupHistories_GetByLatestByValveGroupIdV2(id),
		{ zoneId: id, siteId: getSiteId(state.profile.active) },
	);
};
